module.exports = __webpack_public_path__ + "img/img83.3927d326.png";